import type { JSX } from 'preact';
import {
  MAX_MAP_SIZE,
  MIN_MAP_SIZE,
  type MapDocument,
  type MapMeta,
} from '../../sim/map/index.ts';
import { NumberField } from '../controls.tsx';
import { MapMetaFields } from './mapMeta.tsx';

export type MapSettingsActions = {
  onSetMapMeta: (meta: MapMeta) => void;
  onSetMapSize: (size: Partial<{ width: number; height: number }>) => void;
};

export function MapSettings({
  map,
  onSetMapMeta,
  onSetMapSize,
}: {
  map: MapDocument;
} & MapSettingsActions): JSX.Element {
  return (
    <div class="editor-map-settings">
      <MapMetaFields
        value={map.meta}
        onChange={(patch) => onSetMapMeta({ ...map.meta, ...patch })}
      />
      <NumberField
        label="Map width"
        value={map.bounds.width}
        min={MIN_MAP_SIZE}
        max={MAX_MAP_SIZE}
        step={256}
        onChange={(width) => onSetMapSize({ width })}
      />
      <NumberField
        label="Map height"
        value={map.bounds.height}
        min={MIN_MAP_SIZE}
        max={MAX_MAP_SIZE}
        step={256}
        onChange={(height) => onSetMapSize({ height })}
      />
      <p class="ui-hint">Shrinking the map clamps anything outside the new bounds.</p>
    </div>
  );
}
